module.exports = "/assets/1f5f58488937f5e3e77646b9ada6ffaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/v2-icons/user.svg
// module id = 3317
// module chunks = 0